import tacHelpers from '../../state/tac/tacHelpers';
import { generateOptions } from './generateOptions';
import productService from '../../services/products';

export function findItem(tac, container) {
  const itemid = container.item.itemid;

  return tacHelpers
    .getAllItems(tacHelpers.getItems(tac))
    .find(item => item.itemid === itemid);
}

export function getMenuItems(tac, container) {
  const item = findItem(tac, container);

  const options = generateOptions(item, tac);
  const showInfoIcon = productService.showInfoIcon(item);
  const showTrashCan =
    productService.isRealArticleProduct(item) ||
    item.items?.length ||
    (item.parts && Object.values(item.parts)?.length);

  return {
    options,
    showInfoIcon,
    showTrashCan,
    showConfMenu: showInfoIcon || showTrashCan || options.length,
  };
}
